<template>
    <div class="container-fluid p-4">
        <div class="d-flex flex-row justify-content-between flex-wrap" style="row-gap: 20px">
            <div class="d-flex flex-row" >
                <user-avatar size="large" :user="user"></user-avatar>
                <div class="ms-2">
                    <div class="user-profile__name">{{ user.name }}</div>
                    <div class="user-profile__email">{{ user.email }}</div>
                </div>
            </div>
        </div>
        <div class="divider --vertical-20-48"></div>
        <div class="row mb-2">
            <div class="col-3">Name</div>
            <div  class="col-6">
                <form-input v-model="changeName.name" :v="$v.changeName.name"></form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-3">Password</div>
            <div  class="col-6">
                <div class="d-flex flex-row gap-3">
                    <form-input-password inputClass="form-control" class="flex-1" type="password"
                                         placeholder="Enter password"
                                         v-model="changeName.password"
                                         :v="$v.changeName.password"/>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-end">
            <btn class="btn-outline-light" :loading="loading.changeName" @click="updateName">Change name</btn>
        </div>
        <div class="divider --vertical-20"></div>
        <div class="row form-group">
            <div class="col-3">New password</div>
            <div  class="col-6">
                <form-input-password inputClass="form-control" class="mb-2" type="password"
                                     placeholder="Enter new password"
                                     v-model="changePassword.new_password"
                                     :v="$v.changePassword.new_password"/>
            </div>
        </div>
        <div class="row">
            <div class="col-3">Confirm password</div>
            <div  class="col-6">
                <form-input-password inputClass="form-control" class="mb-2" type="password"
                                     placeholder="Confirm new password"
                                     v-model="changePassword.confirm_password"
                                     :v="$v.changePassword.confirm_password"/>
            </div>
        </div>
        <div class="row">
            <div class="col-3">Current password</div>
            <div  class="col-6">
                <div class="d-flex flex-row gap-3">
                    <form-input-password inputClass="form-control" class="flex-1" type="password"
                                         placeholder="Enter current password"
                                         v-model="changePassword.current_password"
                                         :v="$v.changePassword.current_password"/>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-end">
            <btn class="btn-outline-light" :loading="loading.changePassword" @click="updatePassword">Change password</btn>
        </div>
        <div class="divider --vertical-20"></div>
        <div class="row mb-2 form-group">
            <div class="col-3">Email</div>
            <div  class="col-6">
                <form-input v-model="changeEmail.email" :v="$v.changeEmail.email" placeholder="Enter email"></form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-3">Password</div>
            <div  class="col-6">
                <div class="d-flex flex-row gap-3">
                    <form-input-password inputClass="form-control" class="flex-1" type="password"
                                         placeholder="Enter password"
                                         v-model="changeEmail.password"
                                         :v="$v.changeEmail.password"/>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-end">
            <btn class="btn-outline-light" :loading="loading.changeEmail" @click="updateEmail">Change email</btn>
        </div>
        <div class="divider --vertical-20"></div>
        <div class="row mb-2 form-group">
            <div class="col-3">
                <div>Your photo</div>
                <div style="font-weight: 400">This will be displayed on your profile</div>
            </div>
            <div  class="col-6">
                <profile-image-uploader :is_user_profile="true" image_type="user" :editable="true" v-model="user.profile_image"></profile-image-uploader>
            </div>
        </div>
    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";
import {mapState} from "vuex";
import FormInputPassword from "@/components/core/FormInputPassword.vue";
import {minLength, required, sameAs, email} from "vuelidate/lib/validators";
import ProfileImageUploader from "@/components/ProfileImageUploader.vue";

export default {
    name: "Account",
    components: {ProfileImageUploader, FormInputPassword, UserAvatar},
    computed: {
        ...mapState({
            user: state => state.user,
        })
    },
    validations: {
        changePassword: {
            new_password: {required, minLength: minLength(6)},
            confirm_password: {required, sameAs: sameAs('new_password')},
            current_password: { required },
        },
        changeEmail: {
            password: { required },
            email: {required}
        },
        changeName: {
            password: {required},
            name: {required},
        }
    },
    mounted() {
        this.changeEmail.email = this.user.email;
        this.changeName.name = this.user.name;
    },
    data: function () {
        return {
            loading: {
                changePassword: false,
                changeEmail: false,
                changeName: false,
            },
            changePassword: {
                new_password: '',
                confirm_password: '',
                current_password: '',
            },
            changeEmail: {
                password: '',
                email: ''
            },
            changeName: {
                name: '',
                password: ''
            }
        }
    },
    methods: {
        updatePassword: function () {
            this.$v.changePassword.$touch();
            if (this.$v.changePassword.$invalid === true) {
                return false;
            }
            this.loading.changePassword = true;
            this.$http.post("/auth/change-password", this.changePassword)
                .then(function (res) {
                    this.loading.changePassword = false;
                })
                .catch(function (err) {
                    this.loading.changePassword = false;
                })
        },
        updateEmail: function () {
            this.$v.changeEmail.$touch();
            if (this.$v.changeEmail.$invalid == true) {
                return false;
            }
            this.loading.changeEmail = true;
            this.$http.post("/auth/change-email", this.changeEmail)
                .then(function (res) {
                    this.user.email = res.body.data.email;
                    this.loading.changeEmail = false;
                })
                .catch(function (err) {
                    this.loading.changeEmail = false;
                })
        },

        updateName: function () {
            this.$v.changeName.$touch();
            if (this.$v.changeName.$invalid == true) {
                return false;
            }
            this.loading.changeName = true;
            this.$http.post("/auth/change-name", this.changeName)
                .then(function (res) {
                    this.user.name = res.body.data.name;
                    this.loading.changeName = false;
                })
                .catch(function (err) {
                    this.loading.changeName = false;
                })
        },
    }
}
</script>

<style scoped>

</style>
